import { ApiError, ApiErrorCode } from 'src/error/ApiError';
import { Mixpanel } from 'src/tracking/mixpanel/Mixpanel';
import { MixpanelEvents } from 'src/tracking/mixpanel/MixpanelEvents';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import ModalFlow from 'src/common/ModalFlow';
import { useClientsContext } from '../context/ClientsContext';
import { useCreateFamily } from '../hooks/useCreateFamily';
import { getAdvisorUserId, InProgressFamilyV2, payloadFromInProgressFamilyV2 } from './dataHelpers';
import SelectMembersStep from './SelectMembersStep';

export default function CreateFamilyFlowV2() {
  const { flow, close } = useClientsContext();
  const { createFamily } = useCreateFamily();
  const { currentUser, isSystemAdmin, isServiceAdmin } = useCurrentUser();

  if (flow !== 'create-family') return null;

  const handleCreateFamily = async (family: InProgressFamilyV2) => {
    const advisorUserId = getAdvisorUserId(
      family.selectedMembers,
      currentUser,
      isSystemAdmin,
      isServiceAdmin,
    );

    try {
      await createFamily(payloadFromInProgressFamilyV2(family, advisorUserId));
      Mixpanel.track(MixpanelEvents.FAMILY_CREATED);
      close();
    } catch (error) {
      const message = ApiError.isApiError(ApiErrorCode.CLIENT_ALREADY_IN_FAMILY, error)
        ? error.message
        : 'An error occurred while creating the family. Please try again.';
      notifyAndLogError('Failed to create family', message, error, { familyData: family });
    }
  };

  return (
    <ModalFlow<InProgressFamilyV2>
      steps={[SelectMembersStep]}
      onComplete={handleCreateFamily}
      onClose={close}
    />
  );
}
